import React from 'react';

import type { Atoms } from '@rtkwlf/fenrir-react';
import { Field, Primitive } from '@rtkwlf/fenrir-react';
import type { FieldError, Merge } from 'react-hook-form';

export type Props = {
  label?: string;
  fieldInfo?: string;
  field: React.ReactNode;
  error?: Merge<FieldError, (FieldError | undefined)[]> | undefined;
  warning?: Merge<FieldError, (FieldError | undefined)[]> | undefined;
  maxWidth?: Atoms['maxWidth'];
  isRequired?: boolean;
} & React.ComponentProps<typeof Primitive.div>;

export type WarningProps = {
  warning: Merge<FieldError, (FieldError | undefined)[]> | undefined;
};

const WarningMessage: React.FC<WarningProps> = ({ warning }) => (
  <Primitive.div paddingBottom="default">
    <Field.Root appearance="warning">
      {warning?.message && !Array.isArray(warning) ? (
        <Field.Message>{warning.message}</Field.Message>
      ) : null}
      {Array.isArray(warning) && warning.length > 0
        ? warning.map((warnObj) => (
            <Field.Message key={warnObj.message}>
              {warnObj.message}
            </Field.Message>
          ))
        : null}
    </Field.Root>
  </Primitive.div>
);

export const FieldWrapper: React.FC<Props> = ({
  label,
  fieldInfo,
  field,
  maxWidth,
  error,
  warning,
  isRequired = false,
  ...rest
}) => (
  <Primitive.div width="full" maxWidth={maxWidth || 'full'} {...rest}>
    <Field.Root
      appearance={error?.message || error?.length ? 'danger' : undefined}
      isRequired={isRequired}
    >
      {label && <Field.Label>{label}</Field.Label>}
      {fieldInfo && <Field.Info>{fieldInfo}</Field.Info>}
      <Field.Content>{field}</Field.Content>
      {error?.message && !Array.isArray(error) ? (
        <Field.Message>{error.message}</Field.Message>
      ) : null}
      {Array.isArray(error) && error.length > 0
        ? error.map((errObj) => (
            <Field.Message key={errObj.message}>{errObj.message}</Field.Message>
          ))
        : null}
      {warning && <WarningMessage warning={warning} />}
    </Field.Root>
  </Primitive.div>
);
